// extracted by mini-css-extract-plugin
export default {"cart-items":"Cart_cart-items__m+nKW","total":"Cart_total__NXWOO","actions":"Cart_actions__g8c7E","button--alt":"Cart_button--alt__8JAeP","button":"Cart_button__71xZe"};